import { useMutation } from '@tanstack/react-query';
import { apiClient } from '@/components/api';
import { useInvalidateQueries } from '@/hooks';
import routes from '@/lib/routes';

type TParams = {
	onSuccess?: () => void;
};

export const useRequestDeleteEvent = (params?: TParams) => {
	const { invalidate } = useInvalidateQueries();
	const { isPending, error, mutateAsync } = useMutation({
		mutationKey: [routes.api.events.base, 'delete'],
		mutationFn: (id: string) =>
			apiClient
				.delete(routes.api.events.delete(id))
				.then(res => res.data)
				.catch(error => {
					throw error?.response?.data ?? error;
				}),
		onSuccess: () => {
			invalidate(routes.api.events.base);
			params?.onSuccess?.();
		},
	});

	return {
		isLoading: isPending,
		triggerDeleteEvent: mutateAsync,
		error,
	};
};
